export const commonEn = {
  // Header
  'header.search': 'Search products...',
  'header.cart': 'Cart',
  'header.login': 'Sign in',
  'header.admin': 'Admin Panel',
  'header.distributor': 'Distributor Panel',
  'header.logout': 'Sign out',
  
  // Navigation
  'nav.home': 'Home',
  'nav.windows': 'Windows',
  'nav.office': 'Office',
  'nav.antivirus': 'Antivirus',
  'nav.vpn': 'VPN',
  'nav.testimonials': 'Testimonials',
  'nav.distributor': 'Distributors',
  'nav.legal': 'Legal',
  
  // Hero Slides
  'hero.vpn.title': 'VPN - TOTAL PROTECTION AND PRIVACY',
  'hero.vpn.subtitle': 'UP TO 77% OFF',
  'hero.vpn.description': 'Browse safely and anonymously with the best VPNs on the market',
  'hero.vpn.button': 'View VPN offers',
  'hero.vpn.badge': 'OFFER -77%',
  
  'hero.windows.title': 'WINDOWS 11 LICENSES',
  'hero.windows.subtitle': 'From $65.963',
  'hero.windows.description': 'Upgrade your operating system with the best deals',
  'hero.windows.button': 'Buy now',
  
  'hero.office.title': 'MICROSOFT OFFICE 365',
  'hero.office.subtitle': 'MORE THAN 60% OFF',
  'hero.office.description': 'Professional productivity at the best price',
  'hero.office.button': 'View offers',
  'hero.office.badge': 'OFFER +60%',
  
  // Search
  'search.results': 'Results for:',
  'search.clear': 'Clear',
  'search.noResults': 'No products found',
  'search.noResultsDesc': 'There are no products matching your search',
  'search.viewAll': 'View all products',
  
  // Product Sections
  'section.windows': 'Windows Licenses',
  'section.office': 'Microsoft Office Licenses',
  'section.officeLtsc': 'Office 365 LTSC Licenses',
  'section.antivirus': 'Antivirus',
  'section.vpn': 'VPN - Virtual Private Networks',
  
  // Product Details
  'product.lifetime': 'Lifetime license',
  'product.rating': '(5.0)',
  'product.sold': 'sold',
  'product.badge': 'Offer',
  'product.monthly': 'Monthly',
  'product.multiAccount': 'With 5 accounts, lifetime license with 20% discount',
  
  // CTA Section
  'cta.title': 'IT STORE OR RESELLER?',
  'cta.description': 'Are you an IT store or software reseller? Join our distributor program and enjoy special prices and exclusive conditions.',
  'cta.button': 'Become a Distributor',
  'cta.specialPrices': 'Special Prices',
  'cta.exclusiveConditions': 'Exclusive Conditions',
  'cta.prioritySupport': 'Priority Support',
  
  // Info Boxes
  'info.lowPrices.title': 'Lowest prices',
  'info.lowPrices.desc': 'We offer the best prices on the market for original software licenses. Save up to 70% on your purchases.',
  'info.fastDelivery.title': 'Fast delivery',
  'info.fastDelivery.desc': 'Receive your license instantly by email. No waiting, no complications. Immediate activation.',
  'info.guarantee.title': 'Guaranteed peace of mind',
  'info.guarantee.desc': '24/7 technical support and lifetime warranty on all our perpetual licenses. Your satisfaction is our priority.',
  
  // Footer
  'footer.description': 'Your trusted store for original software licenses. Competitive prices and immediate delivery.',
  'footer.products': 'Products',
  'footer.company': 'Company',
  'footer.support': 'Support',
  'footer.contact': 'Contact',
  'footer.aboutUs': 'About us',
  'footer.terms': 'Terms and conditions',
  'footer.privacy': 'Privacy policy',
  'footer.faq': 'FAQ',
  'footer.help': 'Help center',
  'footer.rights': 'All rights reserved.',
  'footer.poweredBy': 'Built with',
  
  // Payment Methods
  'payment.methods': 'Available payment methods',
  'payment.nequi': 'Nequi',
  'payment.daviplata': 'Daviplata',
  'payment.bancolombia': 'Bancolombia',
  'payment.efecty': 'Efecty',
  'payment.card': 'Card',
  'payment.paypal': 'PayPal',
  'payment.buyNow': 'Buy now',
  
  // Common
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.view': 'View',
  'common.close': 'Close',
};

export default commonEn;
